import CalendarModal from './components/CalendarModal.vue';
import CalendarIcon from './components/CalendarIcon.vue';
import PickADoctor from './components/PickADoctor.vue';
import { ref, onMounted } from 'vue';
import { useToggleModal } from './hooks/useToggleModal.js';
import { useField } from 'vee-validate';
import Calendar from './components/Calendar/Calendar.vue';
import { outputDateFormat } from '../../../helpers/formatDate.js';
import axios from 'axios';


export default {
  __name: 'CalendarSection',
  props: {
    productId: {
        type: Number,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;

function transformDoctorsData(input) {
    let result = [];

    for (let key in input) {
        result.push({
            id: parseInt(key),
            title: input[key],
        });
    }

    return result;
}



const { axis, isOpen, toggleModal, input } = useToggleModal();

const {
    value: selectedDoctorValue,
    errors: selectedDoctorErrors,
    errorMessage: selectedDoctorErrorMsg,
} = useField('selectedDoctor');

const {
    value: selectedCallDateValue,
    errors: selectedCallDateErrors,
    errorMessage: selectedCallDateErrorMsg,
} = useField('selectedConsultationDate');

const scheduleStatus = ref('idle');
const doctorsStatus = ref('idle');
const doctors = ref({});

const schedule = ref({});

const setSchedule = (value) => (schedule.value = value);

const setStatus = (value) => (scheduleStatus.value = value);

onMounted(() => {
    doctorsStatus.value = 'loading';
    const data = new FormData();
    data.append('action', 'wizyta_Iekarze');
    data.append('prod', props.productId);

    axios.post(jsData.ajaxUrl, data).then(({ data }) => {
        if (data.success) {
            doctorsStatus.value = 'success';
            doctors.value = transformDoctorsData(data.data);
        }
    });
});

const __returned__ = { transformDoctorsData, props, axis, isOpen, toggleModal, input, selectedDoctorValue, selectedDoctorErrors, selectedDoctorErrorMsg, selectedCallDateValue, selectedCallDateErrors, selectedCallDateErrorMsg, scheduleStatus, doctorsStatus, doctors, schedule, setSchedule, setStatus, CalendarModal, CalendarIcon, PickADoctor, ref, onMounted, get useToggleModal() { return useToggleModal }, get useField() { return useField }, Calendar, get outputDateFormat() { return outputDateFormat }, get axios() { return axios } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}